/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-restricted-imports
import { DirectoryRecordFragment } from 'api/generated/graphql';
import { DirectoryRecordData } from 'api/types/data';
import { lodash } from 'helpers';

export const parseDirectoryRecordData = (
  record: DirectoryRecordFragment
): DirectoryRecordData => ({
  id: record.id,
  fields: lodash.compact(record.fields).map((field) => ({
    ...field,
    referenceRecord: field.referenceRecord
      ? parseDirectoryRecordData(field.referenceRecord)
      : null,
    value: field.value
      ? field.value.__typename === 'String_container'
        ? field.value.String
        : field.value.__typename === 'Boolean_container'
        ? field.value.Boolean
        : field.value.__typename === 'Float_container'
        ? field.value.Float
        : field.value.__typename === 'MultiLanguageTextDto'
        ? field.value
        : null
      : null,
  })),
});
